// translator は v1 では sallyinc/app 本番直結のみ運用。env 化は将来検討。
const REPO = 'sallyinc/app';

export const compareUrl = (branch: string): string =>
  `https://github.com/${REPO}/compare/main...${encodeURIComponent(branch)}`;

export const branchUrl = (branch: string): string =>
  `https://github.com/${REPO}/tree/${encodeURIComponent(branch)}`;
